import {
  TaxonomyMaterialType,
} from '../implementations';

const mappers = {
  material_type: TaxonomyMaterialType,
};

export default mappers;
